import WagesParamsEditPage from './WagesParamsEditPage';

export default WagesParamsEditPage;